import React from 'react';
import MagasinierHeader from '../components/magasinier-header';

const MagasinierLayout = ({ children }) => {
  return (
    <>
      <MagasinierHeader />
      <main id="main" className="main duo-main-bg">
        <div className="duo-page">{children}</div>
      </main>
    </>
  );
};

export default MagasinierLayout;
